import styled from '@emotion/styled';
import Theme from 'App.theme';
import Button from 'components/Button/Button';
import { Typography } from '@mui/material';

interface ActionBarContainerProps {
  height?: number;
}

interface ButtonContainerProps {
  height?: number;
}

export const ActionBarContainer = styled.div<ActionBarContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${props => (props.height ? `${props.height}px` : '100%')};
  min-height: 400px;
  margin: 5px;
  border: 5px solid ${Theme.greys.GREY1};
  border-radius: 5px;
  box-shadow: 'none';
`;

export const Title = styled(Typography)`
  max-width: 200px;
  text-align: center;
  background-color: ${Theme.greys.GREY1};
`;

export const ButtonContainer = styled.div<ButtonContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: stretch;
  min-width: 200px;
  width: 200px;
  height: ${props => (props.height ? `${props.height - 74}px` : '100%')};
  min-height: 326px; // 400 - 74 = 326
`;

export const ActionButton = styled(Button)`
  margin: 0px 5px;
`;
